import { types } from "../actions";

const initialState = {
  groupDetails: null,
  groupName: "",
  siteName: "",
  groupMembers: [],
};

const userDetailsGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_GROUP_DETAILS:
      const groupDetails = action.payload;
      const tags = groupDetails?.tags || [];
      const sortedTags = tags.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const latestSiteName = sortedTags.length > 0 ? sortedTags[0]?.name : "";
      return {
        ...state,
        groupDetails,
        groupName: groupDetails?.name || "",
        siteName: latestSiteName,
        groupMembers: groupDetails?.users || [],
      };
    default:
      return state;
  }
};

export default userDetailsGroupReducer;
